import { useQuery } from '@apollo/client';
import { useContext, useMemo } from 'react';
import { UserContext } from '../../common/auth/UserContext';
import { searchClient, slimResultsQuery } from '../../common/list/slimQuery';

export const useGetResourceTypes = () => {
    const { activeOrganizationAccount } = useContext(UserContext);

    const { data, loading: fetchingResourceTypes } = useQuery(slimResultsQuery('ResourceType'), {
        client: searchClient,
        variables: {
            page: { from: 0, size: 15 },
            filters: {
                identifier: 'entity',
                value: 'ResourceType'
            }
        },
        fetchPolicy: 'cache-first',
        context: {
            headers: {
                ownerId: activeOrganizationAccount
            }
        },
        notifyOnNetworkStatusChange: true
    });

    const resourceTypes = useMemo(() => {
        if (data?.results?.hits?.items) {
            return data.results.hits.items.map((type) => type.name);
        }
    }, [data?.results?.hits?.items]);

    return { resourceTypes, fetchingResourceTypes };
};
